import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import AboutUsPage from "./pages/AboutUsPage";
import ContactUsPage from "./pages/ContactUsPage";
import BlogListPage from "./pages/BlogListPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import SalemCateringPage from "./pages/SalemCateringPage";

// ── Scroll to top on every route change ──────────────────────
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Placeholder pages — replace with real components as you build them
const PlaceholderPage = ({ title }) => (
  <div className="min-h-screen bg-[#0a1a0f] flex items-center justify-center">
    <h1 className="text-white text-3xl font-light tracking-widest uppercase">
      {title}
    </h1>
  </div>
);

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/pages" element={<PlaceholderPage title="Pages" />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogDetailsPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/best-catering-services-in-salem" element={<SalemCateringPage />} />
        <Route
          path="/privacy"
          element={<PlaceholderPage title="Privacy Policy" />}
        />
        <Route
          path="/terms"
          element={<PlaceholderPage title="Terms & Services" />}
        />
        {/* 404 fallback */}
        <Route
          path="*"
          element={<PlaceholderPage title="404 — Page Not Found" />}
        />
      </Routes>
    </>
  );
};

export default AppRoutes;
